import { render, staticRenderFns } from "./OrdersPopup.vue?vue&type=template&id=e3bff596&"
import script from "./OrdersPopup.vue?vue&type=script&lang=js&"
export * from "./OrdersPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports